import React, { useState } from "react";
import styled from "styled-components";
import {
  UzytkownikWidok,
  StatusUzytkownika
} from "../../store/types/uzytkownicy";
import ContextMenu from "../../components/contextMenu";
import { MenuItem } from "@material-ui/core";
import {
  RolaUzytkownika,
  OrganizacjaWidok
} from "../../store/types/organizacje";
import AlertDialog from "../../components/alertDialog";
import { uzytkownicyActions } from "../../store/actions/uzytkownicy.actions";
import { connect } from "react-redux";
import { IDRaksStore } from "../../store/store";

const UzytkownikElementStyle = styled.div<any>`
  .row {
    height: 56px;
    background: #fff;
    padding: 8px 20px;
    display: grid;
    grid-template-columns: 260px 260px 1fr 160px 24px;
    grid-gap: 12px;
    margin-bottom: 4px;
    align-items: center;

    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .status {
      width: 144px;
      height: 28px;
      background-color: ${(props) =>
    props.status === StatusUzytkownika.Niepotwierdzono
      ? "#fbaa00"
      : props.status === StatusUzytkownika.Potwierdzono
        ? "#10a886"
        : "#cc6666"};
      color: #fff;
      border-radius: 4px;
      text-align: center;
    }
  }
`;

interface UzytkownikElementProps {
  element: UzytkownikWidok;
  onEdit: () => void;
  onDelete: () => void;
  organizacja: OrganizacjaWidok;
  onZaprosPonownie: Function;
  onPrzegladaj: Function;
}

const UzytkownikElement = (props: UzytkownikElementProps) => {
  const {
    element,
    onEdit,
    onDelete,
    onZaprosPonownie,
    organizacja,
    onPrzegladaj
  } = props;
  const [potwierdzUsuniecie, setPotwierdzUsuniecie] = useState(false);

  function dajRole(rola: RolaUzytkownika) {
    switch (rola) {
      case RolaUzytkownika.Wlasciciel:
        return "Właściciel";
      case RolaUzytkownika.Administrator:
        return "Administrator";
      case RolaUzytkownika.Uzytkownik:
        return "Użytkownik";
    }
  }

  function dajStatus(status: StatusUzytkownika) {
    return status === StatusUzytkownika.Niepotwierdzono ? "Wysłano" : status;
  }

  function czyJestDostep(el: UzytkownikWidok) {
    return (
      el.Rola !== RolaUzytkownika.Wlasciciel &&
      (organizacja.Rola === RolaUzytkownika.Wlasciciel ||
        (organizacja.Rola === RolaUzytkownika.Administrator &&
          el.Rola === RolaUzytkownika.Uzytkownik))
    );
  }

  function zapros() {
    onZaprosPonownie(organizacja.Id, element.IdZaproszenia).then(() =>
      onPrzegladaj(organizacja.Id)
    );
  }

  return (
    <>
      <UzytkownikElementStyle status={element.Status}>
        <div className="row high body1">
          <span>
            {element.Imie} {element.Nazwisko}
          </span>
          <span>{element.Email}</span>
          <span>{dajRole(element.Rola)}</span>
          {element.Rola !== RolaUzytkownika.Wlasciciel && (
            <div className="status">{dajStatus(element.Status)}</div>
          )}
          {czyJestDostep(element) && (
            <>
              <ContextMenu>
                <MenuItem onClick={onEdit}>Edytuj</MenuItem>
                {element.Status !== StatusUzytkownika.Potwierdzono && (
                  <MenuItem onClick={zapros}>
                    Wyślij zaproszenie ponownie
                  </MenuItem>
                )}
                <MenuItem onClick={() => setPotwierdzUsuniecie(true)}>
                  Usuń
                </MenuItem>
              </ContextMenu>
            </>
          )}
        </div>
      </UzytkownikElementStyle>
      {potwierdzUsuniecie && (
        <AlertDialog
          mode="YesNo"
          title="Potwierdzenie"
          content="Czy chcesz usunąć wybranego użytkownika?"
          onAccept={() => {
            onDelete();
            setPotwierdzUsuniecie(false);
          }}
          onCancel={() => setPotwierdzUsuniecie(false)}
        ></AlertDialog>
      )}
    </>
  );
};

function mapStateToProps(store: IDRaksStore) {
  return {
    organizacja: store.organizacje.wybrana
  };
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onZaprosPonownie: (idOrg: string, idZapr: string) =>
      dispatch(uzytkownicyActions.zaprosPonownie(idOrg, idZapr)),
    onPrzegladaj: (idOrg: string) =>
      dispatch(uzytkownicyActions.przegladaj(idOrg))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UzytkownikElement);
